module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "s-container"
  }, [_c('ul', {
    staticClass: "s-wrap"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item.Id,
      staticClass: "s-item",
      style: ({
        backgroundImage: ("url('" + (item.Logo) + "')")
      }),
      on: {
        "click": function($event) {
          _vm.showLogo(item)
        }
      }
    })
  })), _vm._v(" "), _c('popup', {
    attrs: {
      "position": "bottom",
      "max-height": "50%"
    },
    model: {
      value: (_vm.isShow),
      callback: function($$v) {
        _vm.isShow = $$v
      },
      expression: "isShow"
    }
  }, [_c('section', {
    staticClass: "detailPanel"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "Logo",
    attrs: {
      "src": _vm.itemInfo.Logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.itemInfo.QrCode),
      expression: "itemInfo.QrCode"
    }],
    staticClass: "qrcode",
    attrs: {
      "src": _vm.itemInfo.QrCode,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h1', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.itemInfo.Name))])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6fb1e154"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Scroller/Scroller.vue
// module id = 521
// module chunks = 1